export const BackendAPI = 'https://climb.blackforestsentinel.de/api'